import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import loadJS from "../helpers/load-js";

import "./gmap.css";
import includes from "lodash-es/includes";
import size from "lodash-es/size";

@Component
class GMapMultiple extends Vue {
    @Prop({ type: Number, default: 50 }) public scale: number;
    @Prop({ type: Number, default: 1 }) public zoom: number;
    @Prop({ type: String, default: null }) public apiKey: string | null;
    @Prop({ type: String, default: null }) public targetUrl: string | null;
    @Prop({ type: String, default: null }) public categories: string | null;
    @Prop({ type: String, default: null }) public cats: string | null;
    @Prop({ type: String, default: null }) public colors: string | null;

    public isLoaded: boolean = false;
    public map: google.maps.Map;
    public marker: google.maps.Marker[] = [];
    public circleMarker: google.maps.Marker[] = [];
    public lat: number[] = [];
    public long: number[] = [];
    public uuid: string[] = [];
    public headline: string[] = [];
    public type: string[] = [];
    public typeArr: any = [];
    public markerObj: any = {};

    public async mounted() {
        let catArr: any = [];
        if(this.categories){ catArr = this.categories.split(','); }
        let colorsArr: any = [];
        if(this.colors){ colorsArr = this.colors.split(','); }

        for(let x = 0; x < catArr.length + 1; x++) {
            this.typeArr[catArr[x]] = colorsArr[x];
        }

        await this.getMapInformation();
        if (!this.apiKey) {
            return;
        }

        window.google = {};
        await loadJS(`https://maps.googleapis.com/maps/api/js?key=${this.apiKey!}`);
        this.initMap();
    }

    private async getMapInformation() {
        const url = `${window.$$jsModelPath}.json`;
        const mapsData: any = await this.getMapsData(url);
        /* const typeObject = mapsData[0][mapsData[0].length - 1]; */
        /* const typeObjectPropNames = Object.getOwnPropertyNames(typeObject); */

        for (let x = 0; x < mapsData[0].length - 1; x++) {
            if (mapsData[0][x].latitude !== undefined && mapsData[0][x].longitude !== undefined && includes(this.categories, mapsData[0][x].type)) {
                this.lat.push(mapsData[0][x].latitude);
                this.long.push(mapsData[0][x].longitude);
                this.uuid.push(mapsData[0][x]["jcr:uuid"]);
                this.headline.push(mapsData[0][x].headline);
                this.type.push(mapsData[0][x].type);
                /*
                for (let y = 0; y < Object.keys(typeObject).length; y++) {
                    const typeName = typeObjectPropNames[y];
                    if (mapsData[0][x].type === typeObject[typeName]["jcr:uuid"]) {
                        this.type.push(typeObject[typeName].name);
                        break;
                    }
                } */
            }
        }
    }

    private async getMapsData(url: string) {
        try {
            const request = `${url}`;
            const result = await fetch(request, {credentials: "include"});
            const json = result.ok ? await result.json() : undefined;

            return new Promise((resolve, reject) => {
                // if (json == undefined || size(json.nodes) < 1) { reject(result.ok ? "No nodes" : result.statusText); }
                if (json == undefined) {
                    reject(result.ok ? "No nodes" : result.statusText);
                }
                else {
                    resolve([json]);
                }
            });
        }
        catch (err) {
            return Promise.reject(err);
        }
    }

    public moveMap() {
        let latAverage = 0;
        let longAverage = 0;
        for (let x = 0; x < this.lat.length && this.long.length; x++) {
            latAverage += this.lat[x];
            longAverage += this.long[x];

            const markerCoords = new google.maps.LatLng(this.lat[x], this.long[x]);
            this.marker[x].setPosition(markerCoords);
            this.circleMarker[x].setPosition(markerCoords);
        }
        latAverage = latAverage / this.lat.length;
        longAverage = longAverage / this.long.length;
        const coords = new google.maps.LatLng(latAverage, longAverage);

        google.maps.event.trigger(this.map, "resize");
        // this.map.panTo(coords);
        this.map.setCenter(coords);
    }

    public initMap() {
        this.map = new google.maps.Map(this.$el, {
            gestureHandling: "cooperative",
            clickableIcons: false,
            zoom: this.zoom,
            center: {lat: 0, lng: 0},
            styles: [
                {
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#f5f5f5",
                        },
                    ],
                },
                {
                    elementType: "labels.icon",
                    stylers: [
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#616161",
                        },
                    ],
                },
                {
                    elementType: "labels.text.stroke",
                    stylers: [
                        {
                            color: "#f5f5f5",
                        },
                    ],
                },
                {
                    featureType: "administrative.land_parcel",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#bdbdbd",
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#eeeeee",
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#757575",
                        },
                    ],
                },
                {
                    featureType: "poi.park",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#e5e5e5",
                        },
                    ],
                },
                {
                    featureType: "poi.park",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#9e9e9e",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                    ],
                },
                {
                    featureType: "road.arterial",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#757575",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#dadada",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#616161",
                        },
                    ],
                },
                {
                    featureType: "road.local",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#9e9e9e",
                        },
                    ],
                },
                {
                    featureType: "transit.line",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#e5e5e5",
                        },
                    ],
                },
                {
                    featureType: "transit.station",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#eeeeee",
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#c9c9c9",
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#9e9e9e",
                        },
                    ],
                },
            ],
        });

        const pointerIcon: any = {
            path: "M10,0.5c5.2,0,9.5,4.3,9.5,9.5S10,35.2,10,35.2S0.5,15.2,0.5,10S4.8,0.5,10,0.5z",
            fillOpacity: 1,
            strokeWeight: 0,
            scaledSize: new google.maps.Size(28, 46),
        };

        const circleIcon: any = {
            path: "M10,5.5c1.9,0,3.5,1.6,3.5,3.5s-1.6,3.5-3.5,3.5S6.5,10.9,6.5,9S8.1,5.5,10,5.5z",
            fillOpacity: 1,
            strokeWeight: 0,
            fillColor: "#fff",
            scaledSize: new google.maps.Size(28, 46),
        };

        // Create markers.
        for (let x = 0; x < this.lat.length; x++) {
            const markerIcon: any = pointerIcon;
            markerIcon.fillColor = "#fd6776";
            if(this.typeArr[this.type[x]]){
                markerIcon.fillColor = this.typeArr[this.type[x]];
            }

            this.marker[x] = new google.maps.Marker({
                position: {lat: 0, lng: 0},
                icon: markerIcon,
                map: this.map,
            });

            this.circleMarker[x] = new google.maps.Marker({
                position: {lat: 0, lng: 0},
                icon: circleIcon,
                map: this.map,
            });

            const marker = this.marker[x];
            const circleMarker = this.circleMarker[x];
            const map = this.map;
            const headline = this.headline[x];
            let infoContent: string;
            if (size(this.targetUrl) > 0) {
                 infoContent = '<div id="content">' +
                    '<a href="' + this.targetUrl + "#/liegenschaften/detail/" + this.uuid[x] + '"><strong id="firstHeading" class="firstHeading" style="padding: 0 1rem;">' + headline + "</strong></a>" +
                    "</div>";
            } else {
                infoContent = '<div id="content">' +
                    '<strong id="firstHeading" class="firstHeading" style="padding: 0 1rem;">' + headline + "</strong>" +
                    "</div>";
            }
            const infoWindow = new google.maps.InfoWindow({
                content: infoContent,
            });

            google.maps.event.addListener(marker, "click", function() {
                map.setCenter(marker.getPosition());
                if (headline !== undefined) {
                    infoWindow.setContent(infoContent);
                    infoWindow.open(map, marker);
                }
            });
            google.maps.event.addListener(circleMarker, "click", function() {
                map.setCenter(marker.getPosition());
                if (headline !== undefined) {
                    infoWindow.setContent(infoContent);
                    infoWindow.open(map, marker);
                }
            });
        }

        this.isLoaded = true;
        if (this.lat !== null && this.long !== null) {
            this.moveMap();
        }
    }
}

export default GMapMultiple;



// WEBPACK FOOTER //
// ./src/components/google-maps-multiple.ts